// extracted by mini-css-extract-plugin
module.exports = {"grid":"StoppedAgreementFeedback_grid__EZJUK","otherFeedback":"StoppedAgreementFeedback_otherFeedback__RG9t6"};